import PromoBg from "assets/png/promo_man_alt_2.png";
import styled from "styled-components";

import EmphasizedSection from "components/EmphasizedSection";

import { BenefitsSection, Container as BaseContainer, HeaderContainerColumn } from "../styles";

const containerHeight = 600;
const promoBgImageHeight = 504;
const containerInnerWidth = 455;

export const Container = styled(BaseContainer)`
  height: ${containerHeight}px;
  background-image: url("${PromoBg}");
  background-size: auto ${promoBgImageHeight}px;
`;

export const HeaderContainer = styled(HeaderContainerColumn)``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: ${containerInnerWidth}px;
`;

export const StyledEmphasizedSection = styled(EmphasizedSection)`
  width: 340px;
  margin-bottom: ${({ theme }) => theme.margin.m24};
  padding: ${({ theme }) => theme.padding.p16};
  border-radius: 16px;

  ${BenefitsSection} {
    margin: 0;
  }
`;
